import React, { useEffect, useState } from 'react'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { enteredToTally } from '../../redux/features/serviceSlice'
import FilterBill from '../../components/user/finance/FilterBill'
import { formatAmount } from '../../assets/javascript/formate-functions'
import FilterTransaction from '../../components/user/finance/FilterTransaction'


const Transactions = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams()
    const { markService } = useSelector((state) => state.service)

    const handleEnteredToTally = (id) => {
        dispatch(enteredToTally(id))
    }


    useEffect(() => {
        accountingAxios.get('/v2/transactions', {
            params: {
                status: searchParams.get('status'),
                mode: searchParams.get('mode'),
                receipt_no: searchParams.get('receipt_no'),
                from_date: searchParams.get('from_date'),
                end_date: searchParams.get('end_date'),
                transaction_id: searchParams.get('transaction_id')
            }
        }).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [searchParams.get('from_date'), searchParams.get('end_date'), searchParams.get('mode'), searchParams.get('receipt_no'),
    // eslint-disable-next-line
    searchParams.get('status'), searchParams.get('transaction_id')
    ])

    const filterModal = () => {
        setModal({
            status: true,
            title: "Filter",
            content: <FilterTransaction setModal={setModal} />
        })
    }

    return (
        <div className="bills-list">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Transactions']}>
                {data[0] ? <TableFilter
                    topRight={<button onClick={filterModal}>Filter</button>}
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Transaction Id</th>
                                <th>Receipt No</th>
                                <th>Method</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Mark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} >
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        {item?.date ? new Date(item?.date).toDateString() : ''}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        {item?.transaction_id}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        {item?.receipt_no}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        {item?.payment_mode}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        ₹ {formatAmount(item?.amount)}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/transaction/${item?.uuid}`)}  >
                                        {item?.transaction_status}
                                    </td>
                                    <td style={{ cursor: 'pointer' }}>
                                        <input type='checkbox' checked={markService?.includes(item.uuid)} onClick={() => handleEnteredToTally(item.uuid)} />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={<>
                            <button onClick={filterModal}>Filter</button>
                        </>} />
                }
            </SinglePage>
        </div >
    )
}

export default Transactions